var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 726.2965879265092 726.2965879265092",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l726.2966 0l0 726.2966l-726.2966 0l0 -726.2966z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l726.2966 0l0 726.2966l-726.2966 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m95.683876 53.904053l534.92914 309.24408l-534.92914 309.24408z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m95.683876 53.904053l534.92914 309.24408l-534.92914 309.24408z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m329.67453 230.43307l434.4567 0l0 665.7953l-434.4567 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m518.09644 539.9799q27.34375 -34.37497 42.71875 -45.31247q20.828125 -15.109375 44.0 -15.109375q27.34375 0 51.171875 19.796875q23.828125 19.78122 23.828125 63.796844q0 30.734375 -8.859375 48.3125q-8.84375 17.578125 -27.59375 28.25q-18.75 10.671875 -38.546875 10.671875q-23.171875 0 -44.0 -14.84375q-15.375 -11.1875 -42.71875 -45.5625q-35.40628 44.53125 -75.25003 44.53125q-26.3125 0 -45.1875 -19.921875q-18.875 -19.921875 -18.875 -49.609375q0 -29.4375 18.875 -49.484375q18.875 -20.046844 45.1875 -20.046844q39.84375 0 75.25003 44.53122zm17.96875 24.734375q22.65625 35.15625 41.40625 48.171875q11.984375 8.59375 26.828125 8.59375q19.78125 0 33.1875 -14.578125q13.421875 -14.578125 13.421875 -41.140625q0 -27.609375 -13.671875 -42.1875q-13.671875 -14.5937195 -33.984375 -14.5937195q-12.75 0 -23.953125 7.2968445q-15.109375 10.15625 -43.234375 48.4375zm-35.93753 0.265625q-20.828125 -26.046875 -33.328125 -33.46875q-12.5 -7.421875 -23.953125 -7.421875q-15.109375 0 -25.140625 10.6875q-10.015625 10.671875 -10.015625 29.421875q0 18.484375 10.40625 29.5625q10.421875 11.0625 25.265625 11.0625q26.296875 0 56.765625 -39.84375z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLoop);
export default __webpack_public_path__ + "static/media/play-loop.856c6ffab5438ee65d5719ef8680019f.svg";
export { ForwardRef as ReactComponent };